import * as React from 'react';
import CSGallery from "../components/CSGallery"
import BrotherGallery from "../components/BrotherGallery"
import PDGallery from "../components/PDGallery"
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/system/Stack';

export default function ActivitiesBody() {
    return (
    <>
        <Container justifyContent="center" maxWidth='md'>
            <br></br>
            <br></br>
            <Grid container rowSpacing={-5} columnSpacing={12}>
                
                <Grid xs={6} md={6}>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <Box display="flex" width='80%' justifyContent='center'>
                    <Stack spacing={2}>
                        <Typography variant='h4' fontFamily='Proxima Nova' gutterBottom>
                            <b>Service</b>
                        </Typography>
                        <Typography variant='body1' fontFamily='Proxima Nova' gutterBottom>
                        Theta Tau Psi Delta Chapter maintains its standard as a service organization. As one of our three guiding pillars, we have service chairs who poll the brothers to find which organizations we are most interested in helping and set up fun events for us to help those in need. We hold a biannual blood drive, environmental cleanups, and other community service events to contribute to the greater Boston area.
                        </Typography>
                    </Stack>
                    </Box>

                </Grid>
                <Grid xs={6} md={6}>
                    <CSGallery />
                </Grid>

                <Grid xs={6} md={6}>
                    <BrotherGallery />
                </Grid>
                <Grid xs={6} md={1.5}></Grid>
                <Grid xs={6} md={4.5}>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <Box display="flex" width='100%' justifyContent='center'>
                    <Stack spacing={2}>
                        <Typography variant='h4' fontFamily='Proxima Nova' gutterBottom>
                            <b>Brotherhood</b>
                        </Typography>
                        <Typography variant='body1' fontFamily='Proxima Nova' gutterBottom>
                        The brotherhood chairs specialize in weaving the fabric of our community. Throughout the semester, they organize engaging events that bring our brothers together in a supportive and inclusive environment where every member feels a sense of belonging.
                        </Typography>
                    </Stack>
                    </Box>
                </Grid>

                <Grid xs={6} md={6}>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <Box display="flex" width='80%' justifyContent='center'>
                    <Stack spacing={2}>
                        <Typography variant='h4' fontFamily='Proxima Nova' gutterBottom>
                            <b>Profession</b>
                        </Typography>
                        <Typography variant='body1' fontFamily='Proxima Nova' gutterBottom>
                        Coming from all types of fields and backgrounds, our brothers' work experience and connections last a lifetime. Their knowledge is always passed down to younger members that wish to follow a similar path. We have two professional development chairs, who are dedicated to helping all of our members gain the professional experience they need to help them beyond their time at BU.
                        </Typography>
                    </Stack>
                    </Box>
                </Grid>
                <Grid xs={6} md={6}>
                    <PDGallery />
                </Grid>
                
            </Grid>
            <br></br>
            <br></br>
        </Container>
    </>
    )
  }